import PropTypes from 'prop-types'
import React from 'react'
import { Table, Card, CardFooter, CardHeader, Button } from 'reactstrap'
import withLoader from 'hocs/with-loader'
import { CardLoader } from 'components/organisms'
import { useHistory } from 'react-router'

const propTypes = {
  shippingAddress: PropTypes.shape({
    id              : PropTypes.number,
    street_address  : PropTypes.string,
    sub_district    : PropTypes.string,
    district        : PropTypes.string,
    city            : PropTypes.string,
    province        : PropTypes.string,
    postal_code     : PropTypes.string,
    recipient_name  : PropTypes.string,
    telephone       : PropTypes.string,
    tl_province     : PropTypes.object,
    tl_city         : PropTypes.object,
    tl_district     : PropTypes.object,
    tl_sub_district : PropTypes.object
  })
}

const defaultProps = {
  shippingAddress: PropTypes.shape({
    id              : 0,
    street_address  : '',
    sub_district    : '',
    district        : '',
    city            : '',
    province        : '',
    postal_code     : '',
    recipient_name  : '',
    telephone       : '',
    tl_province     : {},
    tl_city         : {},
    tl_district     : {},
    tl_sub_district : {}
  })
}

/**
 * @param {object} shippingAddress
 */
const CustomerOrderShippingAddressCard = ({ shippingAddress }) => {
  const history = useHistory()
  return (
    <Card>
      <CardHeader>
        <div>
          <span className='small text-uppercase text-light font-weight-bolder'>
            { 'Customer Address' }
          </span>
          <h2>
            <span className='mr-3'>{ 'Shipping Address' }</span>
          </h2>
        </div>
      </CardHeader>

      <Table
        hover
        responsive
        size={ 'sm' }
        className={ 'mb-0' }
      >
        <tbody>
          <tr>
            <th scope='row'>ID</th>
            <td>{ shippingAddress.id }</td>
          </tr>
          <tr>
            <th scope='row'>Street Address</th>
            <td className='text-wrap'>{ shippingAddress.street_address }</td>
          </tr>
          <tr>
            <th scope='row'>Province</th>
            <td>{ shippingAddress.tl_province && shippingAddress.tl_province.name }</td>
          </tr>
          <tr>
            <th scope='row'>City</th>
            <td>{ shippingAddress.tl_city && shippingAddress.tl_city.name }</td>
          </tr>
          <tr>
            <th scope='row'>District</th>
            <td>{ shippingAddress.tl_district && shippingAddress.tl_district.name }</td>
          </tr>
          <tr>
            <th scope='row'>Sub District</th>
            <td>{ shippingAddress.tl_sub_district && shippingAddress.tl_sub_district.name }</td>
          </tr>
          <tr>
            <th scope='row'>Postal Code</th>
            <td>{ shippingAddress.postal_code }</td>
          </tr>
          <tr>
            <th scope='row'>Recipient Name</th>
            <td>{ shippingAddress.recipient_name }</td>
          </tr>
          <tr>
            <th scope='row'>Recipient Phone</th>
            <td>{ shippingAddress.telephone }</td>
          </tr>
        </tbody>
      </Table>

      <CardFooter>
        <Button
          block
          outline
          color={ 'primary' }
          onClick={ () => history.push(`/app/user-address/${shippingAddress.id}/edit`) }
        >
          { 'Edit' }
        </Button>
      </CardFooter>
    </Card>
  )
}

CustomerOrderShippingAddressCard.propTypes    = propTypes
CustomerOrderShippingAddressCard.defaultProps = defaultProps

export default withLoader(CustomerOrderShippingAddressCard, CardLoader)
